import React from "react";
import { Navigate } from "react-router-dom";
import { UserDetailsPage, USER_TYPES } from "../../modules/user-management";
import useAuth from "../../hooks/useAuth";

const TenantUserDetails = () => {
  const { isSystemUser, activeTenantId } = useAuth();
  if (isSystemUser && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }
  return <UserDetailsPage userType={USER_TYPES.TENANT} />;
};

export default TenantUserDetails;
